import PropTypes from 'prop-types';

import theme from '../../theme';

const defaultProps = {
	backgroundColor: theme.palette.secondary.main,
	foregroundColor: '#fff',
	strokeWidth: '1',
};

const propTypes = {
	backgroundColor: PropTypes.string,
	foregroundColor: PropTypes.string,
	icon: PropTypes.string.isRequired,
	strokeWidth: PropTypes.string,
};

const WeatherIcon = ({
	backgroundColor,
	foregroundColor,
	icon,
	strokeWidth,
}) => (
	<svg viewBox="0 0 64 64">
		{['01', '02', '10'].some((number) => icon.includes(number)) && icon.includes('d') && (
			<g
				className="sun"
				fill="#FFC300"
				stroke={backgroundColor}
				strokeMiterlimit="10"
				strokeWidth={strokeWidth}
			>
				<circle cx="41.886" cy="26.506" r="10" />
				<path d="m34.444 16.235c0.862 0.862 0.926 2.192 0.145 2.974-0.78 0.781-2.111 0.717-2.974-0.145l-2.539-2.539c-0.86-0.861-0.925-2.192-0.145-2.973 0.781-0.781 2.112-0.717 2.974 0.144l2.539 2.539z" />
				<path d="m29.361 24.506c1.219 0 2.205 0.896 2.205 2s-0.986 2-2.205 2h-3.591c-1.218 0-2.204-0.896-2.204-2s0.986-2 2.204-2h3.591z" />
				<path d="m31.615 33.949c0.861-0.862 2.193-0.926 2.975-0.145 0.78 0.781 0.716 2.112-0.146 2.973l-2.539 2.539c-0.86 0.861-2.192 0.925-2.974 0.145-0.78-0.781-0.716-2.112 0.145-2.973l2.539-2.539z" />
				<path d="m39.886 39.032c0-1.218 0.896-2.205 2-2.205s2 0.987 2 2.205v3.591c0 1.217-0.896 2.204-2 2.204s-2-0.987-2-2.204v-3.591z" />
				<path d="m49.329 36.777c-0.861-0.862-0.926-2.192-0.146-2.973 0.781-0.781 2.112-0.717 2.975 0.145l2.539 2.539c0.861 0.861 0.925 2.192 0.144 2.973-0.78 0.781-2.111 0.717-2.973-0.145l-2.539-2.539z" />
				<path d="m54.412 28.506c-1.219 0-2.205-0.896-2.205-2s0.986-2 2.205-2h3.591c1.218 0 2.204 0.896 2.204 2s-0.986 2-2.204 2h-3.591z" />
				<path d="m52.158 19.064c-0.861 0.861-2.193 0.926-2.975 0.145-0.78-0.781-0.716-2.112 0.146-2.974l2.539-2.539c0.86-0.861 2.192-0.925 2.974-0.144 0.78 0.781 0.716 2.112-0.145 2.973l-2.539 2.539z" />
				<path d="m43.886 13.981c0 1.218-0.896 2.205-2 2.205s-2-0.987-2-2.205v-3.591c0-1.217 0.896-2.204 2-2.204s2 0.987 2 2.204v3.591z" />
			</g>
		)}
		{['01', '02', '10'].some((number) => icon.includes(number)) && icon.includes('n') && (
			<path
				className="moon w-01n w-02n w-10n"
				d="m59.928 25.032c-1.229 7.189-7.489 12.641-15.02 12.641-8.43 0-15.25-6.821-15.25-15.25 0-8.36 6.72-15.15 15.07-15.25-2.141 2.13-3.471 5.08-3.471 8.33 0 6.5 5.271 11.77 11.771 11.77 2.581-1e-3 4.961-0.831 6.9-2.241z"
				fill={foregroundColor}
				stroke={backgroundColor}
				strokeMiterlimit="10"
				strokeWidth={strokeWidth}
			/>
		)}
		{['04', '09', '11', '13'].some((number) => icon.includes(number)) && (
			<path
				className="cloud-dark w-04d w-04n w-09d w-09n w-11d w-11n w-13d w-13n"
				d="m52.17 41.231c3.982 0 7.217-3.234 7.217-7.226 0-3.723-2.835-6.799-6.461-7.181-1.244-4.968-5.732-8.64-11.084-8.64-4.559 0-8.505 2.676-10.345 6.543-0.116-0.01-0.24-0.01-0.355-0.01-4.569 0-8.267 3.697-8.267 8.258 0 4.559 3.697 8.256 8.267 8.256h21.028z"
				fill="#808285"
				stroke={backgroundColor}
				strokeMiterlimit="10"
				strokeWidth={strokeWidth}
			/>
		)}
		{['02', '03', '04', '05', '09', '10', '11', '13'].some((number) => icon.includes(number)) && (
			<path
				className="cloud"
				d="m37.514 48.353c4.479 0 8.119-3.639 8.119-8.129 0-4.189-3.189-7.65-7.27-8.08-1.4-5.59-6.45-9.721-12.471-9.721-5.129 0-9.569 3.011-11.639 7.361-0.131-0.011-0.271-0.011-0.4-0.011-5.141 0-9.301 4.16-9.301 9.291 0 5.129 4.16 9.289 9.301 9.289h23.661z"
				fill={foregroundColor}
				stroke={backgroundColor}
				strokeMiterlimit="10"
				strokeWidth={strokeWidth}
			/>
		)}
		{['09', '10'].some((number) => icon.includes(number)) && (
			<g
				className="rain"
				fill="#213f99"
				stroke={backgroundColor}
				strokeMiterlimit="10"
				strokeWidth={strokeWidth}
			>
				<path d="m30.06 45.717c0 1.911-1.55 3.461-3.461 3.461-1.912 0-3.462-1.55-3.462-3.461s3.462-5.796 3.462-5.796 3.461 3.885 3.461 5.796z" />
				<path d="m22.705 52.522c0 1.912-1.549 3.461-3.461 3.461-1.911 0-3.461-1.549-3.461-3.461 0-1.91 3.461-5.795 3.461-5.795s3.461 3.885 3.461 5.795z" />
				<path d="m33.521 54.325c0 1.911-1.55 3.461-3.461 3.461-1.912 0-3.461-1.55-3.461-3.461 0-1.912 3.461-5.797 3.461-5.797s3.461 3.885 3.461 5.797z" />
			</g>
		)}
		{['50'].some((number) => icon.includes(number)) && (
			<g
				className="mist"
				stroke={backgroundColor}
				strokeMiterlimit="10"
				strokeWidth={strokeWidth}
			>
				<path d="m45.633 45.854c0 0.977-0.745 1.768-1.664 1.768h-36.672c-0.919 0-1.664-0.791-1.664-1.768 0-0.975 0.745-1.766 1.664-1.766h36.672c0.919 1e-3 1.664 0.792 1.664 1.766z" />
				<path d="m40.588 50.042c0 0.977-0.745 1.768-1.664 1.768h-34.939c-0.919 0-1.664-0.791-1.664-1.768 0-0.975 0.745-1.766 1.664-1.766h34.939c0.919 0 1.664 0.791 1.664 1.766z" />
				<path d="m43.909 54.916c0 0.976-0.745 1.767-1.664 1.767h-30.74c-0.919 0-1.664-0.791-1.664-1.767s0.745-1.767 1.664-1.767h30.739c0.92 0 1.665 0.791 1.665 1.767z" />
			</g>
		)}
		{['13'].some((number) => icon.includes(number)) && (
			<g
				className="snow"
				fill={foregroundColor}
				stroke="#120F0E"
				strokeMiterlimit="10"
				strokeWidth={strokeWidth}
			>
				<circle cx="16.625" cy="51.229" r="2.708" />
				<circle cx="22.042" cy="51.229" r="2.708" />
				<circle cx="27.458" cy="51.229" r="2.708" />
				<circle cx="32.875" cy="51.229" r="2.708" />
				<circle cx="14.583" cy="57.104" r="2.708" />
				<circle cx="20" cy="57.104" r="2.708" />
				<circle cx="25.416" cy="57.104" r="2.708" />
				<circle cx="30.833" cy="57.104" r="2.708" />
			</g>
		)}
		{['11'].some((number) => icon.includes(number)) && (
			<polygon
				className="thunder"
				fill="#FFC300"
				stroke={backgroundColor}
				strokeMiterlimit="10"
				strokeWidth={strokeWidth}
				points="27.01,38 16.76,49.62 22.53,49.46 21.53,58 31.24,45.34 26.08,45.4"
			/>
		)}
	</svg>
);

WeatherIcon.defaultProps = defaultProps;
WeatherIcon.propTypes = propTypes;

export default WeatherIcon;
